import anime from 'animejs';
import { initials, animations } from '@/scripts/animations';
import { inApp, isTouchDevice } from './utils';

export default class Loader {
  constructor(slider) {
    this.resources = slider.illustrations;
    this.slider = slider;

    if (!inApp()) this.setInitials();
    this.init();
  }

  init() {
    document.body.classList.add('is-loading');
    if (!inApp()) {
      Promise.all(
        [
          this.loadImage(this.slider.illustrations[0]),
          this.loadImage(this.slider.illustrations[1]),
          this.loadImage(this.slider.illustrations[2]),
          this.loadImage(this.slider.illustrations[3]),
        ],
      ).then(() => {
        setTimeout(() => {
          document.body.classList.remove('is-loading');
          this.slider.enter();
          this.enter();
          this.slider.items.forEach((item) => item.setBg());
        }, 800);
      });
    } else {
      this.loadImage(this.slider.illustrations[0]).then(() => {
        document.body.classList.remove('is-loading');
        this.slider.items[0].setBg();
        this.slider.enter();
        this.slider.addEvents();

        Promise.all(
          [
            this.loadImage(this.slider.illustrations[1]),
            this.loadImage(this.slider.illustrations[2]),
            this.loadImage(this.slider.illustrations[3]),
          ],
        ).then(() => this.slider.items.forEach((item, i) => {
          if (i !== 0) item.setBg();
        }));
      });
    }
  }

  async loadImage(src) {
    const img = document.createElement('img');
    img.decoding = 'sync';

    const fallback = new Promise((resolve) => {
      const imageHandler = () => {
        img.removeEventListener('load', imageHandler);
        img.remove();

        resolve(img);
      };

      img.addEventListener('load', imageHandler());
      img.src = '/textures/displace.jpg';
    });

    if (img.decode) {
      img.src = src;
      await img.decode();
    } else {
      await fallback();
    }

    return img;
  }

  setInitials() {
    const bigtitle = document.querySelector('.logo');
    const button = document.querySelector('.puzzle-button');
    const arrowButton = document.querySelector('.footer__content');
    const subtitle = document.querySelector('.header__subtitle');
    const soundButton = document.querySelector('.app-audio');

    initials.get('bigtitle')(bigtitle);
    initials.get('button')(button);
    initials.get('arrowButton')(arrowButton);
    initials.get('subtitle')(subtitle);
    anime.set(soundButton, { scale: 0 });
    anime.set('.footer__croccat', { opacity: 0, translateY: 30 });

    if (!isTouchDevice() && window.innerWidth > 768) {
      const arrowLeft = document.querySelector('[data-navposition="left"]');
      const arrowRight = document.querySelector('[data-navposition="right"]');

      initials.get('navigationItem')(arrowLeft, 'left');
      initials.get('navigationItem')(arrowRight, 'right');
    }
  }

  enter() {
    const bigtitle = document.querySelector('.logo');
    const button = document.querySelector('.puzzle-button');
    const arrowButton = document.querySelector('.footer__content');
    const subtitle = document.querySelector('.header__subtitle');
    const soundButton = document.querySelector('.app-audio');

    animations.get('button')(button, 1600);
    animations.get('subtitle')(subtitle, 1800);
    animations.get('bigtitle')(bigtitle, 2000);
    animations.get('arrowButton')(arrowButton, 2600).finished.then(() => this.slider.addEvents());
    anime({ targets: soundButton, scale: 1, delay: 2800 });
    anime({
      targets: '.footer__croccat',
      opacity: 1,
      translateY: 0,
      duration: 1000,
      delay: 2600,
    });

    setTimeout(() => {
      document.querySelector('.app__image').remove();
    }, 1000);

    if (!isTouchDevice() && window.innerWidth > 768) {
      const arrowLeft = document.querySelector('[data-navposition="left"]');
      const arrowRight = document.querySelector('[data-navposition="right"]');

      animations.get('navigationItem')(arrowRight, 1000);
      animations.get('navigationItem')(arrowLeft, 1000);
    }
  }
}
